import _ from 'lodash';
import {createHelpers} from 'vuex-map-fields';
import Vue from 'vue';
import TestSuite from '../../api/testSuite';

/* eslint-disable no-shadow */

// initial state
const state = {
  // TODO FIXME it seems that when we re-use anything in vuex like this (testSuite) there's a chance of state spill over
  // TODO FIXME sometimes it looks like a view is loading with the wrong data and then it swaps to the correct data when the action mutates the store
  // TODO FIXME but in some case (like the editor) that first update was setting the wrong code and was getting stuck there unless you did a refresh
  // TODO FIXME I fixed tests and amacros by moving out of the store and this one I fixed with waiting for a full load before doing the set on the editor
  // TODO FIXME but keep in mind that even a resetTests or restTestSuites in the beforeDestory seemed to miss sometimes and then you can get in a bad state
  // TODO FIXME not sure if that ultimately has to do with the editor weakness and how we wired it up, but in the end it caused code loss for me and others
  // TODO FIXME it might be prudent to never share an object (like testSuite below) when it change change - e.g. when its a user then we should really only have the one user
  // TODO FIXME not sure about super user environements, but it seems to me that vuex/flux kicked my butt here and I lost a lot.
  // Going to leave this for now for some reason, maybe in the future I should be indexing into the array of testSuites rather than using the same object for multiple
  testSuite: {
    environments: [],
    data: [],
    extensions: [],
    tests: [],
    autoRun: {},
    notifications: [],
    schedule: {}
  }, // Active/Selected One
  testSuites: [],  // Current Window of Pagination
  map: {},
  tableOptions: {},
  filter: {
    tags: [],
    tests: []
  },
  dirty: 0 // increments on each mutation
};


// Because by default, getters and mutations in Vuex
// modules, are globally accessible and not namespaced,
// you most likely want to rename the getter and mutation
// helpers because otherwise you can't reuse them in multiple,
// non namespaced modules.
const {getTestSuiteField, mutateTestSuiteField} = createHelpers({
  getterType: 'getTestSuiteField',
  mutationType: 'mutateTestSuiteField'
});

// getters - all receive state as first argument
const getters = {
  getTestSuiteDirty: (state) => state.dirty,
  getTestSuite: (state) => state.testSuite,
  getTestSuites: (state) => state.testSuites,
  getTestSuitesTotal: (state) => state.total,
  getTestSuiteTableOptions: (state) => state.tableOptions,
  getTestSuiteFilter: (state) => state.filter,
  getTestSuiteField
};

// actions
const actions = {
  async getTestSuite({commit}, guid) {
    const testSuite = await TestSuite.get(guid);
    commit('setTestSuite', testSuite);
  },
  async setTestSuiteRunGuid({commit}, {guid, runGuid}) {
    commit('setTestSuiteRunGuid', {guid, runGuid});
  }
};

// mutations
const mutations = {
  setTestSuites(state, testSuites) {
    state.testSuites = testSuites;
    _.each(testSuites, (suite) => {
      Vue.set(state.map, suite.guid, suite);
    });
  },
  setTestSuite(state, testSuite) {
    state.testSuite = testSuite;
    for (let i = 0; i < state.testSuites.length; ++i) {
      if (state.testSuites[i].guid === testSuite.guid) {
        // https://vuejs.org/2016/02/06/common-gotchas/
        state.testSuites.splice(i, 1, testSuite);
      }
    }
    // https://vuejs.org/2016/02/06/common-gotchas/
    Vue.set(state.map, testSuite.guid, testSuite);
  },
  setTestSuiteRunGuid(state, {guid, runGuid}) {
    const testSuite = state.testSuites.find((ts) => ts.guid === guid);
    testSuite.runGuid = runGuid;
  },
  setTestSuiteTableOptions(state, options) {
    state.tableOptions = options;
  },
  setTestSuiteFilter(state, filter) {
    state.filter = filter;
  },
  appendTestSuiteTag(state, tag) {
    if (!state.filter.tags.includes(tag)) {
      state.filter.tags.push(tag);
    } else {
      state.filter.tags = state.filter.tags.filter((t) => t !== tag);
    }
  },
  mutateTestSuiteField
};

export default {
  state,
  getters,
  actions,
  mutations
};
